import { Directive } from '@angular/core';

import { AbstractFormFieldComponent } from '../FormField/abstract-form-field.component';
import { ConfirmDialogComponent } from '../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../Dialogs/models/confirm-dialog.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { SaveStylesDialogComponent } from '../../../../Common/Dialogs/components/SaveStylesDialog/save-styles-dialog.component';
import { SaveTwigTemplateDialogModel } from '../../../../Common/Dialogs/models/save-twig-template-dialog.model';
import { Style } from '../../../../Common/Styles/models/style.model';
import { StyleStateEnum } from '../../enums/style-state.enum';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { StyleTypesApiEnum } from '../../../../api/styles/enum/style-types-api.enum';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class AbstractBaseStyleFieldComponent extends AbstractFormFieldComponent {

    public styleModel: Style;
    // The template may get set onto the block for the edit dialog to work, but it needs to be deleted if cancel is pressed, this tracks that
    protected setTemplate: boolean = false;
    protected internalUser: boolean = false;

    protected saveTwigTemplateDialogModel: SaveTwigTemplateDialogModel = {
        inputs: {
            type: null,
            inputStyle: null
        },
        outputs: {
            dialogClose: (response) => {
                if (response) {
                    this.setStyle(response, 'displayStyleState', true);
                } else {
                    if (this.setTemplate) {
                        this.setTemplate = false;
                        delete this.styleModel.template;
                    }
                }
            }
        }
    };

    constructor(
        protected coreDialogService: CoreDialogService
    ) {
        super();
    }

    /**
     * Handles changes to date styles
     */
    setStyle(
        event: any, // can be string, number, MonitoringTextStyleModel, boolean
        property: string,
        skipCheck: boolean = false
    ) {
        if (property !== 'displayStyleState') {
            if (this['isMentionCustomization']) {
                if (!this.value.isSavedStyle() || !this.internalUser) {
                    this.value.displayStyleState = StyleStateEnum.CUSTOM;
                    this.value.styleState = this.value.getDefaultReference();
                    delete this.value.defaultReference;
                }
            } else {
                this.value.displayStyleState = StyleStateEnum.CUSTOM;
                this.value.styleState = this.value.getDefaultReference();
                delete this.value.defaultReference;
            }
        } else if (
            property === 'displayStyleState' &&
            this.value.displayStyleState === StyleStateEnum.CUSTOM &&
            !skipCheck
        ) {
            const confirmDialogModel: ConfirmDialogModel = {
                inputs: {
                    heading: 'Styles.updateStyleConfirmationDialog.header',
                    showCancel: true,
                    alertType: messageSeverityEnum.warning,
                    alertMessage: 'Styles.updateStyleConfirmationDialog.alertMessage',
                    message: 'Styles.updateStyleConfirmationDialog.message',
                    okLabel: 'Styles.updateStyleConfirmationDialog.confirmButton'
                },
                outputs: {
                    dialogClose: async (response) => {
                        if (response) {
                            if (property) {
                                this.value[property] = event;
                            } else {
                                this.value = event;
                            }
                            this.value[property] = event;
                            this.value.styleState = event;
                            if (this.value.isSavedStyle()) {
                                this.updateStyleFromSavedStyle();
                            }

                            this.changes.emit(this.value);
                        } else {
                            // The dropdown will have already changed values, have to change it back
                            this.value.displayStyleState = StyleStateEnum.CUSTOM;
                            this.displayStyleStateChanged();

                            this.changes.emit(this.value);
                        }
                    }
                }
            };
            this.coreDialogService.open(ConfirmDialogComponent, confirmDialogModel);

            return;
        } else if (
            property === 'displayStyleState'
        ) {
            this.value.styleState = event;
        }

        if (property) {
            this.value[property] = event;
        } else {
            this.value = event;
        }

        if (
            property === 'displayStyleState' &&
            this.value.isSavedStyle()
        ) {
            this.updateStyleFromSavedStyle();
        }

        this.changes.emit(this.value);
    }

    protected updateStyleFromSavedStyle() {}

    protected displayStyleStateChanged(): void {
        return;
    }

    public saveStyle(type?: StyleTypesApiEnum): void {
        if (!this.styleModel) {
            this.styleModel = new Style();
        }

        this.styleModel.style = this.value;

        const io: DialogIoModel = {
            inputs: {
                type: type ?? null,
                inputStyle: this.styleModel
            },
            outputs: {
                dialogClose: (response) => {
                    if (response) {
                        this.setStyle(response, 'displayStyleState', true);
                    }
                }
            }
        };

        this.coreDialogService.open(SaveStylesDialogComponent, io);
    }
}
